export default "__VITE_ASSET__DbCKsxKO__"